export default class hero {
  constructor(el) {
    this.el = el;
    this.vimeoPlayer = null;
    this.cookieRequirements = {
      name: 'OptanonConsent',
      value: 'C0003%3A1',
    };
    this.init();
  }

  init() {
    this.shouldVideoBePlayed();
    this.cookieObserver();
  }

  shouldVideoBePlayed() {
    if (this.checkForCookieValue(this.cookieRequirements.name, this.cookieRequirements.value)) {
      this.createVimeoScript();
      this.loadVimeoVideo();
    }
  }

  checkForCookieValue(name, value) {
    var match = document.cookie.match(new RegExp('(^| )(' + name + '=)([^;]+|)(' + value + ')'));
    return match;
  }

  createVimeoScript() {
    var tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  bindVimeoEvents() {
    this.vimeoPlayer.setVolume(0);
    this.vimeoPlayer.setLoop(true);
    this.vimeoPlayer.play();
    this.vimeoPlayer.ready().then(function () {
      var muteVideo = true;
      document.querySelector('.hero--vimeo-video').classList.add('vimeo-loaded');
    });
  }

  loadVimeoVideo() {
    const vimeoHero = document.querySelector('.hero--vimeo-video');
    if (!vimeoHero) {
      return;
    }

    const vimeoUrl = vimeoHero.getAttribute('data-vimeo-url');
    if (vimeoUrl === '' || vimeoUrl === null) {
      return;
    }
    const regex = '/(player.vimeo.com/)((video/))?([0-9]+)|(vimeo.com/)?([0-9]+)/g';
    const urlWithoutParams = vimeoUrl.match(regex)[0];
    const vimeoID = urlWithoutParams.substring(urlWithoutParams.lastIndexOf('/') + 1);
    let vimeoOptions = {
      id: vimeoID,
      loop: 1,
    };

    if (window.Vimeo) {
      this.vimeoPlayer = new Vimeo.Player('hero--vimeo-video', vimeoOptions);
      this.bindVimeoEvents();
    } else {
      this.vimeoIntervalID = setInterval(() => {
        if (window.Vimeo) {
          window.clearInterval(this.vimeoIntervalID);
          this.vimeoPlayer = new Vimeo.Player('hero--vimeo-video', vimeoOptions);
          this.bindVimeoEvents();
        }
      }, 200);
    }
  }

  cookieObserver() {
    const cookieEvent = new CustomEvent('cookieChanged', {
      bubbles: true,
      detail: {
        cookieValue: document.cookie,
        checkChange: () => {
          return cookieEvent.detail.cookieValue === document.cookie
            ? false
            : (cookieEvent.detail.cookieValue = document.cookie);
        },
        listenCheckChange: () => {
          setInterval(() => {
            if (cookieEvent.detail.checkChange()) {
              cookieEvent.detail.changed = true;
              cookieEvent.target.dispatchEvent(cookieEvent);
            } else {
              cookieEvent.detail.changed = false;
            }
          }, 1000);
        },
        changed: false,
      },
    });

    document.addEventListener('cookieChanged', (e) => {
      e.detail.listenCheckChange();
      if (e.detail.changed === true) {
        this.shouldVideoBePlayed();
      }
    });
    const cookieEventDispatcher = (e) => {
      e.target.dispatchEvent(cookieEvent);
    };

    window.addEventListener('load', cookieEventDispatcher);
  }
}
